<template>
<ItpWidgetCard>
  <ItpBox
    alignItems="center"
    slot="header"
  >
    <strong>
      {{ 'Rentals'|pgettext('FixedAssetRentals') }}
    </strong>
    <ItpButton
      :text="'Assign to rental...'|pgettext('FixedAssetRentals')"
      variant="light"
      size="sm"
      class="ml-auto"
      @click.prevent.stop="evh_3343864469950044_clickPreventStop($event, {})"
    >
    </ItpButton>
  </ItpBox>
  <BListGroup
    v-if="loaded"
  >
    <BListGroupItem
      v-if="!items.length"
    >
      <span>
        {{ 'No rentals.'|pgettext('FixedAssetRentals') }}
      </span>
    </BListGroupItem>
    <BListGroupItem
      :key="item.id"
      class="d-flex flex-column"
      v-for="item in sortItems(items)"
    >
    </BListGroupItem>
  </BListGroup>
</ItpWidgetCard>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcFixedAssetRentals extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  sortItems(...args: any[]) {
    return _.sortBy(args[0], p => (!this.isStale(p) ? "_" + p.service.name : p.service.name).toLowerCase() + p.id)
  }

  isStale(...args: any[]) {
    const [item] = args;
    return item.inactive ||
      (item.valid_to && this.$fn.parseISODate(item.valid_to) < this.today)
  }

  @Prop({
    required: true,
    type: Object,
  })
  fixedAsset!: object;

  @Watch('fixedAsset')
  onFixed_asset(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("fixedAsset")
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_rental_assets', { parameters: { asset: this.fixedAsset.id } })
  }

  ux!: any;
  dataMembers = ['items', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        ux: null,
      },
    }
  }

  async act_3343864469950044_emit_6796_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3343864469950044_emit_6796, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_3343864469950044_close_6795_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_3343864469950044_close_6795, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_3343864469950044_showModal_6794_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_3343864469950044_showModal_6794, alias=undefined
    return {
      name: "RentalService",
      props: {
        meter: this.meter,
        assignToRental: true,
        preventEditMeter: true,
      }
      ,
    }
  }

  async evh_3343864469950044_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_3343864469950044_emit_6796: actions.EmitAction;
    evh_3343864469950044_close_6795: actions.EventHandlerImpl;
    act_3343864469950044_showModal_6794: actions.ShowModalAction;
    evh_3343864469950044_clickPreventStop_6793: actions.EventHandlerImpl;
    evh_3343864469950044_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_3343864469950044_emit_6796 = new actions.EmitAction(
      {
        actionArgs: this.act_3343864469950044_emit_6796_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_close_6795 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_emit_6796,
        event: "close",
        when: this.evh_3343864469950044_close_6795_getWhen,
        displayName: "emit",
      }
    );
    const act_3343864469950044_showModal_6794 = new actions.ShowModalAction(
      {
        actionArgs: this.act_3343864469950044_showModal_6794_getActionArgs,
        events: [evh_3343864469950044_close_6795],
      }
    );
    const evh_3343864469950044_clickPreventStop_6793 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_showModal_6794,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_3343864469950044_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_clickPreventStop_6793],
      }
    );
    return {
      act_3343864469950044_emit_6796,
      evh_3343864469950044_close_6795,
      act_3343864469950044_showModal_6794,
      evh_3343864469950044_clickPreventStop_6793,
      evh_3343864469950044_clickPreventStop,
    }
  }
}

Vue.component("UcFixedAssetRentals", UcFixedAssetRentals);

</script>